import basketOpenClose from "./components/basketOpenClose";
import initTooltip from "./components/initTooltip";
import LoadTemplates from "./components/loadTemplates";

export default function indexCart() {
  jQuery(function () {
    LoadTemplates();
    basketOpenClose();
    initTooltip();
  })
};